import styled, { css } from 'styled-components'
import { Element as ReactScrollElement } from 'react-scroll'
import { Create } from '@material-ui/icons'
import palette from 'theme/palette'

interface CardContainerProps {
  isSelected: boolean
}

export const EditButton = styled.button`
  background-color: #e8e5eb;
  color: ${palette.primary.main};
  padding: 10px;
  text-transform: uppercase;
  border: none;
  border-radius: 5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  cursor: pointer;
  margin-left: auto;
  font-family: 'Roboto', sans-serif;
`

export const Element = styled(ReactScrollElement)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
`

export const NextStepButton = styled.button`
  font-family: 'Roboto', sans-serif;
  margin-top: 33px;
  margin-left: auto;
  padding: 9px 12px;
  background-color: ${palette.primary.main};
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 10px;
    margin-left: 10px;
  }
`
export const CardContainer = styled.div<CardContainerProps>`
  ${({ isSelected }) => css`
    pointer-events: ${isSelected ? 'none' : 'auto'};
    opacity: ${isSelected ? 0.3 : 1};
  `}
`
export const Title = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-size: 22px;
  margin-bottom: 24px;
  color: #263238;
  width: 100%;
`

export const CreateIcon = styled(Create).attrs({
  fontSize: 'small'
})`
  margin-left: 5px;
  font-size: 18px;
`
